import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import ScoreMarketFormModal from 'r/ui/ScoreMarketFormModal';
import type { ScoreMarket } from 'r/types';
import { useScoreMarket } from './queries';

export default function ScoreMarketEditRoute() {
  const { marketId } = useParams<{ marketId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Look for the market in the list cache (instant if coming from the list)
  const cachedMarket = queryClient
    .getQueriesData<{ data: ScoreMarket[] }>({
      queryKey: ['score-markets', 'list'],
    })
    .flatMap(([, page]) => page?.data ?? [])
    .find((m) => m.id === marketId);

  // Fallback fetch by ID for direct links
  const { data: fetchedMarket } = useScoreMarket(
    cachedMarket ? undefined : marketId,
  );
  const market = cachedMarket ?? fetchedMarket ?? undefined;

  const handleClose = () => {
    if (location.state?.background) {
      navigate(-1);
    } else {
      navigate('/?tab=score-markets');
    }
  };

  if (!market) return null;

  return (
    <ScoreMarketFormModal mode="edit" market={market} onClose={handleClose} />
  );
}
